/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkInsertMontageplanBlockDto } from '../models/work-insert-montageplan-block-dto';
import { WorkMontageplanAbsenceSlimDto } from '../models/work-montageplan-absence-slim-dto';
import { WorkMontageplanBacklogDto } from '../models/work-montageplan-backlog-dto';
import { WorkMontageplanBacklogGroupEnum } from '../models/work-montageplan-backlog-group-enum';
import { WorkMontageplanBacklogTypeEnum } from '../models/work-montageplan-backlog-type-enum';
import { WorkMontageplanBlockDateDto } from '../models/work-montageplan-block-date-dto';
import { WorkMontageplanBlockDetailDto } from '../models/work-montageplan-block-detail-dto';
import { WorkMontageplanBlockDiffDtoEvent } from '../models/work-montageplan-block-diff-dto-event';
import { WorkMontageplanBlockMutationResultDto } from '../models/work-montageplan-block-mutation-result-dto';
import { WorkMontageplanBlocksListDto } from '../models/work-montageplan-blocks-list-dto';
import { WorkMontageplanDayDto } from '../models/work-montageplan-day-dto';
import { WorkMontageplanLockStatusDtoEvent } from '../models/work-montageplan-lock-status-dto-event';
import { WorkMontageplanLog } from '../models/work-montageplan-log';
import { WorkMontageplanNoteVisibilityRoleDto } from '../models/work-montageplan-note-visibility-role-dto';
import { WorkMontageplanSyncStatusDtoEvent } from '../models/work-montageplan-sync-status-dto-event';
import { WorkMontageplanUserAvailabilityDto } from '../models/work-montageplan-user-availability-dto';
import { WorkMontageplanUsersDto } from '../models/work-montageplan-users-dto';
import { WorkMoveMontageplanBlockDto } from '../models/work-move-montageplan-block-dto';
import { WorkSuccessDto } from '../models/work-success-dto';
import { WorkUpdateFixedDateDto } from '../models/work-update-fixed-date-dto';
import { WorkUpdateMontageplanBlockDatesDto } from '../models/work-update-montageplan-block-dates-dto';
import { WorkUpdateMontageplanNoteDto } from '../models/work-update-montageplan-note-dto';

@Injectable({ providedIn: 'root' })
export class WorkMontageplanV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `montageplanV2ControllerGetMontageplanBlocksByTeamIdAndDaterange()` */
  static readonly MontageplanV2ControllerGetMontageplanBlocksByTeamIdAndDaterangePath = '/v2/projects/montageplan/blocks/byTeamsAndDaterange/{fromDate}/{toDate}';

  /**
   * Use GET /v2/projects/montageplan/calendar-blocks/:fromDate/:toDate instead.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `montageplanV2ControllerGetMontageplanBlocksByTeamIdAndDaterange()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  montageplanV2ControllerGetMontageplanBlocksByTeamIdAndDaterange$Response(
    params: {
      fromDate: string;
      toDate: string;
      teamIds: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkMontageplanDayDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMontageplanV2Service.MontageplanV2ControllerGetMontageplanBlocksByTeamIdAndDaterangePath, 'get');
    if (params) {
      rb.path('fromDate', params.fromDate, {});
      rb.path('toDate', params.toDate, {});
      rb.query('teamIds', params.teamIds, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkMontageplanDayDto>>;
      })
    );
  }

  /**
   * Use GET /v2/projects/montageplan/calendar-blocks/:fromDate/:toDate instead.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `montageplanV2ControllerGetMontageplanBlocksByTeamIdAndDaterange$Response()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  montageplanV2ControllerGetMontageplanBlocksByTeamIdAndDaterange(
    params: {
      fromDate: string;
      toDate: string;
      teamIds: Array<string>;
    },
    context?: HttpContext
  ): Observable<Array<WorkMontageplanDayDto>> {
    return this.montageplanV2ControllerGetMontageplanBlocksByTeamIdAndDaterange$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkMontageplanDayDto>>): Array<WorkMontageplanDayDto> => r.body)
    );
  }

  /** Path part for operation `montageplanV2ControllerGetMontageplanCalendarBlocks()` */
  static readonly MontageplanV2ControllerGetMontageplanCalendarBlocksPath = '/v2/projects/montageplan/calendar-blocks/{fromDate}/{toDate}';

  /**
   * Required permissions: montageplan:read, montageplan:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `montageplanV2ControllerGetMontageplanCalendarBlocks()` instead.
   *
   * This method doesn't expect any request body.
   */
  montageplanV2ControllerGetMontageplanCalendarBlocks$Response(
    params: {
      fromDate: string;
      toDate: string;
      teamIds: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMontageplanBlocksListDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMontageplanV2Service.MontageplanV2ControllerGetMontageplanCalendarBlocksPath, 'get');
    if (params) {
      rb.path('fromDate', params.fromDate, {});
      rb.path('toDate', params.toDate, {});
      rb.query('teamIds', params.teamIds, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMontageplanBlocksListDto>;
      })
    );
  }

  /**
   * Required permissions: montageplan:read, montageplan:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `montageplanV2ControllerGetMontageplanCalendarBlocks$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  montageplanV2ControllerGetMontageplanCalendarBlocks(
    params: {
      fromDate: string;
      toDate: string;
      teamIds: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkMontageplanBlocksListDto> {
    return this.montageplanV2ControllerGetMontageplanCalendarBlocks$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMontageplanBlocksListDto>): WorkMontageplanBlocksListDto => r.body)
    );
  }

  /** Path part for operation `montageplanV2ControllerGetMontageplanBlockDetail()` */
  static readonly MontageplanV2ControllerGetMontageplanBlockDetailPath = '/v2/projects/montageplan/blocks/{blockType}/{id}/detail';

  /**
   * Required permissions: montageplan:read, montageplan:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `montageplanV2ControllerGetMontageplanBlockDetail()` instead.
   *
   * This method doesn't expect any request body.
   */
  montageplanV2ControllerGetMontageplanBlockDetail$Response(
    params: {
      blockType: string;
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMontageplanBlockDetailDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMontageplanV2Service.MontageplanV2ControllerGetMontageplanBlockDetailPath, 'get');
    if (params) {
      rb.path('blockType', params.blockType, {});
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMontageplanBlockDetailDto>;
      })
    );
  }

  /**
   * Required permissions: montageplan:read, montageplan:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `montageplanV2ControllerGetMontageplanBlockDetail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  montageplanV2ControllerGetMontageplanBlockDetail(
    params: {
      blockType: string;
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkMontageplanBlockDetailDto> {
    return this.montageplanV2ControllerGetMontageplanBlockDetail$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMontageplanBlockDetailDto>): WorkMontageplanBlockDetailDto => r.body)
    );
  }

  /** Path part for operation `montageplanV2ControllerGetTeamTasksForTeamAndDaterange()` */
  static readonly MontageplanV2ControllerGetTeamTasksForTeamAndDaterangePath = '/v2/projects/montageplan/team-tasks/{teamId}/{fromDate}/{toDate}';

  /**
   * Required permissions: montageplan:read, montageplan:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `montageplanV2ControllerGetTeamTasksForTeamAndDaterange()` instead.
   *
   * This method doesn't expect any request body.
   */
  montageplanV2ControllerGetTeamTasksForTeamAndDaterange$Response(
    params: {
      teamId: number;
      fromDate: string;
      toDate: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkMontageplanAbsenceSlimDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMontageplanV2Service.MontageplanV2ControllerGetTeamTasksForTeamAndDaterangePath, 'get');
    if (params) {
      rb.path('teamId', params.teamId, {});
      rb.path('fromDate', params.fromDate, {});
      rb.path('toDate', params.toDate, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkMontageplanAbsenceSlimDto>>;
      })
    );
  }

  /**
   * Required permissions: montageplan:read, montageplan:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `montageplanV2ControllerGetTeamTasksForTeamAndDaterange$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  montageplanV2ControllerGetTeamTasksForTeamAndDaterange(
    params: {
      teamId: number;
      fromDate: string;
      toDate: string;
    },
    context?: HttpContext
  ): Observable<Array<WorkMontageplanAbsenceSlimDto>> {
    return this.montageplanV2ControllerGetTeamTasksForTeamAndDaterange$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkMontageplanAbsenceSlimDto>>): Array<WorkMontageplanAbsenceSlimDto> => r.body)
    );
  }

  /** Path part for operation `montageplanV2ControllerGetMontageplanBlocksByUserIdAndDaterange()` */
  static readonly MontageplanV2ControllerGetMontageplanBlocksByUserIdAndDaterangePath = '/v2/projects/montageplan/blocks/byUserAndDaterange/{userId}/{fromDate}/{toDate}';

  /**
   * Required permissions: montageplan:read, montageplan:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `montageplanV2ControllerGetMontageplanBlocksByUserIdAndDaterange()` instead.
   *
   * This method doesn't expect any request body.
   */
  montageplanV2ControllerGetMontageplanBlocksByUserIdAndDaterange$Response(
    params: {
      userId: number;
      fromDate: string;
      toDate: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkMontageplanDayDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMontageplanV2Service.MontageplanV2ControllerGetMontageplanBlocksByUserIdAndDaterangePath, 'get');
    if (params) {
      rb.path('userId', params.userId, {});
      rb.path('fromDate', params.fromDate, {});
      rb.path('toDate', params.toDate, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkMontageplanDayDto>>;
      })
    );
  }

  /**
   * Required permissions: montageplan:read, montageplan:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `montageplanV2ControllerGetMontageplanBlocksByUserIdAndDaterange$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  montageplanV2ControllerGetMontageplanBlocksByUserIdAndDaterange(
    params: {
      userId: number;
      fromDate: string;
      toDate: string;
    },
    context?: HttpContext
  ): Observable<Array<WorkMontageplanDayDto>> {
    return this.montageplanV2ControllerGetMontageplanBlocksByUserIdAndDaterange$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkMontageplanDayDto>>): Array<WorkMontageplanDayDto> => r.body)
    );
  }

  /** Path part for operation `montageplanV2ControllerGetMontageplanBacklog()` */
  static readonly MontageplanV2ControllerGetMontageplanBacklogPath = '/v2/projects/montageplan/backlog';

  /**
   * Required permissions: montageplan:read, montageplan:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `montageplanV2ControllerGetMontageplanBacklog()` instead.
   *
   * This method doesn't expect any request body.
   */
  montageplanV2ControllerGetMontageplanBacklog$Response(
    params?: {
      type?: WorkMontageplanBacklogTypeEnum;
      group?: WorkMontageplanBacklogGroupEnum;
      search?: string;

    /**
     * Komma-separierte IDs
     */
      businessunitIds?: string;

    /**
     * Komma-separierte IDs
     */
      containertypeIds?: string;

    /**
     * Komma-separierte IDs, wirkt nur auf Termine
     */
      standardtaskIds?: string;

    /**
     * Komma-separierte Task-Status, wirkt nur auf Termine
     */
      taskStatuses?: string;

    /**
     * Termine nicht verkaufter Projekte einbeziehen
     */
      includeNotSold?: string;
      page?: string;
      limit?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMontageplanBacklogDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMontageplanV2Service.MontageplanV2ControllerGetMontageplanBacklogPath, 'get');
    if (params) {
      rb.query('type', params.type, {});
      rb.query('group', params.group, {});
      rb.query('search', params.search, {});
      rb.query('businessunitIds', params.businessunitIds, {});
      rb.query('containertypeIds', params.containertypeIds, {});
      rb.query('standardtaskIds', params.standardtaskIds, {});
      rb.query('taskStatuses', params.taskStatuses, {});
      rb.query('includeNotSold', params.includeNotSold, {});
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMontageplanBacklogDto>;
      })
    );
  }

  /**
   * Required permissions: montageplan:read, montageplan:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `montageplanV2ControllerGetMontageplanBacklog$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  montageplanV2ControllerGetMontageplanBacklog(
    params?: {
      type?: WorkMontageplanBacklogTypeEnum;
      group?: WorkMontageplanBacklogGroupEnum;
      search?: string;

    /**
     * Komma-separierte IDs
     */
      businessunitIds?: string;

    /**
     * Komma-separierte IDs
     */
      containertypeIds?: string;

    /**
     * Komma-separierte IDs, wirkt nur auf Termine
     */
      standardtaskIds?: string;

    /**
     * Komma-separierte Task-Status, wirkt nur auf Termine
     */
      taskStatuses?: string;

    /**
     * Termine nicht verkaufter Projekte einbeziehen
     */
      includeNotSold?: string;
      page?: string;
      limit?: string;
    },
    context?: HttpContext
  ): Observable<WorkMontageplanBacklogDto> {
    return this.montageplanV2ControllerGetMontageplanBacklog$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMontageplanBacklogDto>): WorkMontageplanBacklogDto => r.body)
    );
  }

  /** Path part for operation `montageplanV2ControllerMoveBlock()` */
  static readonly MontageplanV2ControllerMoveBlockPath = '/v2/projects/montageplan/blocks/move';

  /**
   * Required permissions: montageplan:move, montageplan:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `montageplanV2ControllerMoveBlock()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  montageplanV2ControllerMoveBlock$Response(
    params: {
      body: WorkMoveMontageplanBlockDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMontageplanBlockMutationResultDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMontageplanV2Service.MontageplanV2ControllerMoveBlockPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMontageplanBlockMutationResultDto>;
      })
    );
  }

  /**
   * Required permissions: montageplan:move, montageplan:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `montageplanV2ControllerMoveBlock$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  montageplanV2ControllerMoveBlock(
    params: {
      body: WorkMoveMontageplanBlockDto
    },
    context?: HttpContext
  ): Observable<WorkMontageplanBlockMutationResultDto> {
    return this.montageplanV2ControllerMoveBlock$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMontageplanBlockMutationResultDto>): WorkMontageplanBlockMutationResultDto => r.body)
    );
  }

  /** Path part for operation `montageplanV2ControllerMarkAsBuilt()` */
  static readonly MontageplanV2ControllerMarkAsBuiltPath = '/v2/projects/montageplan/blocks/markAsBuilt/{projectId}';

  /**
   * Required permissions: montageplan:update, montageplan:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `montageplanV2ControllerMarkAsBuilt()` instead.
   *
   * This method doesn't expect any request body.
   */
  montageplanV2ControllerMarkAsBuilt$Response(
    params: {
      projectId: number;
      updateInstallationEnd?: boolean;

    /**
     * Optimistic-concurrency guard. Row version the caller saw when issuing the mutation.
     */
      expectedVersion: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMontageplanBlockMutationResultDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMontageplanV2Service.MontageplanV2ControllerMarkAsBuiltPath, 'post');
    if (params) {
      rb.path('projectId', params.projectId, {});
      rb.query('updateInstallationEnd', params.updateInstallationEnd, {});
      rb.query('expectedVersion', params.expectedVersion, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMontageplanBlockMutationResultDto>;
      })
    );
  }

  /**
   * Required permissions: montageplan:update, montageplan:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `montageplanV2ControllerMarkAsBuilt$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  montageplanV2ControllerMarkAsBuilt(
    params: {
      projectId: number;
      updateInstallationEnd?: boolean;

    /**
     * Optimistic-concurrency guard. Row version the caller saw when issuing the mutation.
     */
      expectedVersion: number;
    },
    context?: HttpContext
  ): Observable<WorkMontageplanBlockMutationResultDto> {
    return this.montageplanV2ControllerMarkAsBuilt$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMontageplanBlockMutationResultDto>): WorkMontageplanBlockMutationResultDto => r.body)
    );
  }

  /** Path part for operation `montageplanV2ControllerInsertBlock()` */
  static readonly MontageplanV2ControllerInsertBlockPath = '/v2/projects/montageplan/blocks/insert';

  /**
   * Required permissions: montageplan:insert, montageplan:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `montageplanV2ControllerInsertBlock()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  montageplanV2ControllerInsertBlock$Response(
    params: {
      body: WorkInsertMontageplanBlockDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMontageplanBlockMutationResultDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMontageplanV2Service.MontageplanV2ControllerInsertBlockPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMontageplanBlockMutationResultDto>;
      })
    );
  }

  /**
   * Required permissions: montageplan:insert, montageplan:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `montageplanV2ControllerInsertBlock$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  montageplanV2ControllerInsertBlock(
    params: {
      body: WorkInsertMontageplanBlockDto
    },
    context?: HttpContext
  ): Observable<WorkMontageplanBlockMutationResultDto> {
    return this.montageplanV2ControllerInsertBlock$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMontageplanBlockMutationResultDto>): WorkMontageplanBlockMutationResultDto => r.body)
    );
  }

  /** Path part for operation `montageplanV2ControllerUpdateFixedDate()` */
  static readonly MontageplanV2ControllerUpdateFixedDatePath = '/v2/projects/montageplan/blocks/updateFixedDate';

  /**
   * Required permissions: montageplan:update, montageplan:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `montageplanV2ControllerUpdateFixedDate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  montageplanV2ControllerUpdateFixedDate$Response(
    params: {
      body: WorkUpdateFixedDateDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMontageplanBlockMutationResultDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMontageplanV2Service.MontageplanV2ControllerUpdateFixedDatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMontageplanBlockMutationResultDto>;
      })
    );
  }

  /**
   * Required permissions: montageplan:update, montageplan:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `montageplanV2ControllerUpdateFixedDate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  montageplanV2ControllerUpdateFixedDate(
    params: {
      body: WorkUpdateFixedDateDto
    },
    context?: HttpContext
  ): Observable<WorkMontageplanBlockMutationResultDto> {
    return this.montageplanV2ControllerUpdateFixedDate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMontageplanBlockMutationResultDto>): WorkMontageplanBlockMutationResultDto => r.body)
    );
  }

  /** Path part for operation `montageplanV2ControllerGetLogsForBlock()` */
  static readonly MontageplanV2ControllerGetLogsForBlockPath = '/v2/projects/montageplan/blocks/logs/{blockType}/{id}';

  /**
   * Required permissions: montageplan:read, montageplan:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `montageplanV2ControllerGetLogsForBlock()` instead.
   *
   * This method doesn't expect any request body.
   */
  montageplanV2ControllerGetLogsForBlock$Response(
    params: {
      blockType: string;
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkMontageplanLog>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMontageplanV2Service.MontageplanV2ControllerGetLogsForBlockPath, 'get');
    if (params) {
      rb.path('blockType', params.blockType, {});
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkMontageplanLog>>;
      })
    );
  }

  /**
   * Required permissions: montageplan:read, montageplan:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `montageplanV2ControllerGetLogsForBlock$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  montageplanV2ControllerGetLogsForBlock(
    params: {
      blockType: string;
      id: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkMontageplanLog>> {
    return this.montageplanV2ControllerGetLogsForBlock$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkMontageplanLog>>): Array<WorkMontageplanLog> => r.body)
    );
  }

  /** Path part for operation `montageplanV2ControllerGetNewEnddateForBlock()` */
  static readonly MontageplanV2ControllerGetNewEnddateForBlockPath = '/v2/projects/montageplan/blocks/newEnddate/{blockType}/{id}/{newStartDate}';

  /**
   * Required permissions: montageplan:read, montageplan:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `montageplanV2ControllerGetNewEnddateForBlock()` instead.
   *
   * This method doesn't expect any request body.
   */
  montageplanV2ControllerGetNewEnddateForBlock$Response(
    params: {
      blockType: string;
      id: number;
      newStartDate: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMontageplanBlockDateDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMontageplanV2Service.MontageplanV2ControllerGetNewEnddateForBlockPath, 'get');
    if (params) {
      rb.path('blockType', params.blockType, {});
      rb.path('id', params.id, {});
      rb.path('newStartDate', params.newStartDate, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMontageplanBlockDateDto>;
      })
    );
  }

  /**
   * Required permissions: montageplan:read, montageplan:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `montageplanV2ControllerGetNewEnddateForBlock$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  montageplanV2ControllerGetNewEnddateForBlock(
    params: {
      blockType: string;
      id: number;
      newStartDate: string;
    },
    context?: HttpContext
  ): Observable<WorkMontageplanBlockDateDto> {
    return this.montageplanV2ControllerGetNewEnddateForBlock$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMontageplanBlockDateDto>): WorkMontageplanBlockDateDto => r.body)
    );
  }

  /** Path part for operation `montageplanV2ControllerUpdateMontageplanBlockDates()` */
  static readonly MontageplanV2ControllerUpdateMontageplanBlockDatesPath = '/v2/projects/montageplan/blocks/updateDates';

  /**
   * Required permissions: montageplan:update, montageplan:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `montageplanV2ControllerUpdateMontageplanBlockDates()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  montageplanV2ControllerUpdateMontageplanBlockDates$Response(
    params: {
      body: WorkUpdateMontageplanBlockDatesDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMontageplanBlockMutationResultDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMontageplanV2Service.MontageplanV2ControllerUpdateMontageplanBlockDatesPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMontageplanBlockMutationResultDto>;
      })
    );
  }

  /**
   * Required permissions: montageplan:update, montageplan:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `montageplanV2ControllerUpdateMontageplanBlockDates$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  montageplanV2ControllerUpdateMontageplanBlockDates(
    params: {
      body: WorkUpdateMontageplanBlockDatesDto
    },
    context?: HttpContext
  ): Observable<WorkMontageplanBlockMutationResultDto> {
    return this.montageplanV2ControllerUpdateMontageplanBlockDates$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMontageplanBlockMutationResultDto>): WorkMontageplanBlockMutationResultDto => r.body)
    );
  }

  /** Path part for operation `montageplanV2ControllerListenToBlockDiff()` */
  static readonly MontageplanV2ControllerListenToBlockDiffPath = '/v2/projects/montageplan/blocks/diff';

  /**
   * Required permissions: montageplan:read, montageplan:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `montageplanV2ControllerListenToBlockDiff()` instead.
   *
   * This method doesn't expect any request body.
   */
  montageplanV2ControllerListenToBlockDiff$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMontageplanBlockDiffDtoEvent>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMontageplanV2Service.MontageplanV2ControllerListenToBlockDiffPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/event-stream', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMontageplanBlockDiffDtoEvent>;
      })
    );
  }

  /**
   * Required permissions: montageplan:read, montageplan:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `montageplanV2ControllerListenToBlockDiff$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  montageplanV2ControllerListenToBlockDiff(
    params?: {
    },
    context?: HttpContext
  ): Observable<WorkMontageplanBlockDiffDtoEvent> {
    return this.montageplanV2ControllerListenToBlockDiff$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMontageplanBlockDiffDtoEvent>): WorkMontageplanBlockDiffDtoEvent => r.body)
    );
  }

  /** Path part for operation `montageplanV2ControllerGetMontageplanUsersByTeamIdAndDaterange()` */
  static readonly MontageplanV2ControllerGetMontageplanUsersByTeamIdAndDaterangePath = '/v2/projects/montageplan/users/byTeamsAndDaterange/{fromDate}/{toDate}';

  /**
   * Required permissions: montageplan:read, montageplan:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `montageplanV2ControllerGetMontageplanUsersByTeamIdAndDaterange()` instead.
   *
   * This method doesn't expect any request body.
   */
  montageplanV2ControllerGetMontageplanUsersByTeamIdAndDaterange$Response(
    params: {
      fromDate: string;
      toDate: string;
      teamIds: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMontageplanUsersDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMontageplanV2Service.MontageplanV2ControllerGetMontageplanUsersByTeamIdAndDaterangePath, 'get');
    if (params) {
      rb.path('fromDate', params.fromDate, {});
      rb.path('toDate', params.toDate, {});
      rb.query('teamIds', params.teamIds, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMontageplanUsersDto>;
      })
    );
  }

  /**
   * Required permissions: montageplan:read, montageplan:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `montageplanV2ControllerGetMontageplanUsersByTeamIdAndDaterange$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  montageplanV2ControllerGetMontageplanUsersByTeamIdAndDaterange(
    params: {
      fromDate: string;
      toDate: string;
      teamIds: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkMontageplanUsersDto> {
    return this.montageplanV2ControllerGetMontageplanUsersByTeamIdAndDaterange$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMontageplanUsersDto>): WorkMontageplanUsersDto => r.body)
    );
  }

  /** Path part for operation `montageplanV2ControllerGetMontageplanNoteVisibility()` */
  static readonly MontageplanV2ControllerGetMontageplanNoteVisibilityPath = '/v2/projects/montageplan/users/note-visibility';

  /**
   * Required permissions: montageplan:notes, montageplan:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `montageplanV2ControllerGetMontageplanNoteVisibility()` instead.
   *
   * This method doesn't expect any request body.
   */
  montageplanV2ControllerGetMontageplanNoteVisibility$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkMontageplanNoteVisibilityRoleDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMontageplanV2Service.MontageplanV2ControllerGetMontageplanNoteVisibilityPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkMontageplanNoteVisibilityRoleDto>>;
      })
    );
  }

  /**
   * Required permissions: montageplan:notes, montageplan:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `montageplanV2ControllerGetMontageplanNoteVisibility$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  montageplanV2ControllerGetMontageplanNoteVisibility(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkMontageplanNoteVisibilityRoleDto>> {
    return this.montageplanV2ControllerGetMontageplanNoteVisibility$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkMontageplanNoteVisibilityRoleDto>>): Array<WorkMontageplanNoteVisibilityRoleDto> => r.body)
    );
  }

  /** Path part for operation `montageplanV2ControllerUpdateMontageplanNote()` */
  static readonly MontageplanV2ControllerUpdateMontageplanNotePath = '/v2/projects/montageplan/users/note/{userId}/{workdate}';

  /**
   * Required permissions: montageplan:notes, montageplan:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `montageplanV2ControllerUpdateMontageplanNote()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  montageplanV2ControllerUpdateMontageplanNote$Response(
    params: {
      userId: number;
      workdate: string;
      body: WorkUpdateMontageplanNoteDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMontageplanV2Service.MontageplanV2ControllerUpdateMontageplanNotePath, 'put');
    if (params) {
      rb.path('userId', params.userId, {});
      rb.path('workdate', params.workdate, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: montageplan:notes, montageplan:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `montageplanV2ControllerUpdateMontageplanNote$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  montageplanV2ControllerUpdateMontageplanNote(
    params: {
      userId: number;
      workdate: string;
      body: WorkUpdateMontageplanNoteDto
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.montageplanV2ControllerUpdateMontageplanNote$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `montageplanV2ControllerGetUserAvailabilityForWorkdate()` */
  static readonly MontageplanV2ControllerGetUserAvailabilityForWorkdatePath = '/v2/projects/montageplan/users/availability/{fromDate}/{toDate}';

  /**
   * Required permissions: montageplan:read, montageplan:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `montageplanV2ControllerGetUserAvailabilityForWorkdate()` instead.
   *
   * This method doesn't expect any request body.
   */
  montageplanV2ControllerGetUserAvailabilityForWorkdate$Response(
    params: {
      fromDate: string;
      toDate: string;
      inMyTeam?: boolean;
      businessdivisionId?: number;
      notBusinessdivisionId?: number;
      userId?: number;
      notAssignedToTeam?: boolean;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkMontageplanUserAvailabilityDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMontageplanV2Service.MontageplanV2ControllerGetUserAvailabilityForWorkdatePath, 'get');
    if (params) {
      rb.path('fromDate', params.fromDate, {});
      rb.path('toDate', params.toDate, {});
      rb.query('inMyTeam', params.inMyTeam, {});
      rb.query('businessdivisionId', params.businessdivisionId, {});
      rb.query('notBusinessdivisionId', params.notBusinessdivisionId, {});
      rb.query('userId', params.userId, {});
      rb.query('notAssignedToTeam', params.notAssignedToTeam, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkMontageplanUserAvailabilityDto>>;
      })
    );
  }

  /**
   * Required permissions: montageplan:read, montageplan:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `montageplanV2ControllerGetUserAvailabilityForWorkdate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  montageplanV2ControllerGetUserAvailabilityForWorkdate(
    params: {
      fromDate: string;
      toDate: string;
      inMyTeam?: boolean;
      businessdivisionId?: number;
      notBusinessdivisionId?: number;
      userId?: number;
      notAssignedToTeam?: boolean;
    },
    context?: HttpContext
  ): Observable<Array<WorkMontageplanUserAvailabilityDto>> {
    return this.montageplanV2ControllerGetUserAvailabilityForWorkdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkMontageplanUserAvailabilityDto>>): Array<WorkMontageplanUserAvailabilityDto> => r.body)
    );
  }

  /** Path part for operation `montageplanV2ControllerUnassignUserFromTeam()` */
  static readonly MontageplanV2ControllerUnassignUserFromTeamPath = '/v2/projects/montageplan/users/unassignFromTeam/{userId}/{teamId}/{dateFrom}/{dateTo}';

  /**
   * Required permissions: montageplan:update, montageplan:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `montageplanV2ControllerUnassignUserFromTeam()` instead.
   *
   * This method doesn't expect any request body.
   */
  montageplanV2ControllerUnassignUserFromTeam$Response(
    params: {
      userId: number;
      teamId: number;
      dateFrom: string;
      dateTo: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMontageplanV2Service.MontageplanV2ControllerUnassignUserFromTeamPath, 'delete');
    if (params) {
      rb.path('userId', params.userId, {});
      rb.path('teamId', params.teamId, {});
      rb.path('dateFrom', params.dateFrom, {});
      rb.path('dateTo', params.dateTo, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: montageplan:update, montageplan:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `montageplanV2ControllerUnassignUserFromTeam$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  montageplanV2ControllerUnassignUserFromTeam(
    params: {
      userId: number;
      teamId: number;
      dateFrom: string;
      dateTo: string;
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.montageplanV2ControllerUnassignUserFromTeam$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `montageplanV2ControllerAssignUserToTeam()` */
  static readonly MontageplanV2ControllerAssignUserToTeamPath = '/v2/projects/montageplan/users/assignToTeam/{userId}/{teamId}/{dateFrom}/{dateTo}';

  /**
   * Required permissions: montageplan:update, montageplan:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `montageplanV2ControllerAssignUserToTeam()` instead.
   *
   * This method doesn't expect any request body.
   */
  montageplanV2ControllerAssignUserToTeam$Response(
    params: {
      userId: number;
      teamId: number;
      dateFrom: string;
      dateTo: string;
      isTeamlead: boolean;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMontageplanV2Service.MontageplanV2ControllerAssignUserToTeamPath, 'post');
    if (params) {
      rb.path('userId', params.userId, {});
      rb.path('teamId', params.teamId, {});
      rb.path('dateFrom', params.dateFrom, {});
      rb.path('dateTo', params.dateTo, {});
      rb.query('isTeamlead', params.isTeamlead, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: montageplan:update, montageplan:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `montageplanV2ControllerAssignUserToTeam$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  montageplanV2ControllerAssignUserToTeam(
    params: {
      userId: number;
      teamId: number;
      dateFrom: string;
      dateTo: string;
      isTeamlead: boolean;
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.montageplanV2ControllerAssignUserToTeam$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `montageplanV2ControllerCalculateStatusForProject()` */
  static readonly MontageplanV2ControllerCalculateStatusForProjectPath = '/v2/projects/montageplan/projects/calculateStatus/{projectId}';

  /**
   * Required permissions: montageplan:read, montageplan:update, montageplan:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `montageplanV2ControllerCalculateStatusForProject()` instead.
   *
   * This method doesn't expect any request body.
   */
  montageplanV2ControllerCalculateStatusForProject$Response(
    params: {
      projectId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMontageplanV2Service.MontageplanV2ControllerCalculateStatusForProjectPath, 'post');
    if (params) {
      rb.path('projectId', params.projectId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: montageplan:read, montageplan:update, montageplan:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `montageplanV2ControllerCalculateStatusForProject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  montageplanV2ControllerCalculateStatusForProject(
    params: {
      projectId: number;
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.montageplanV2ControllerCalculateStatusForProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `montageplanV2ControllerListenToSyncStatus()` */
  static readonly MontageplanV2ControllerListenToSyncStatusPath = '/v2/projects/montageplan/projects/syncStatus';

  /**
   * Required permissions: montageplan:read, montageplan:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `montageplanV2ControllerListenToSyncStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  montageplanV2ControllerListenToSyncStatus$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMontageplanSyncStatusDtoEvent>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMontageplanV2Service.MontageplanV2ControllerListenToSyncStatusPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/event-stream', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMontageplanSyncStatusDtoEvent>;
      })
    );
  }

  /**
   * Required permissions: montageplan:read, montageplan:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `montageplanV2ControllerListenToSyncStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  montageplanV2ControllerListenToSyncStatus(
    params?: {
    },
    context?: HttpContext
  ): Observable<WorkMontageplanSyncStatusDtoEvent> {
    return this.montageplanV2ControllerListenToSyncStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMontageplanSyncStatusDtoEvent>): WorkMontageplanSyncStatusDtoEvent => r.body)
    );
  }

  /** Path part for operation `montageplanV2ControllerCalculateStatusForTask()` */
  static readonly MontageplanV2ControllerCalculateStatusForTaskPath = '/v2/projects/montageplan/tasks/calculateStatus/{taskId}';

  /**
   * Required permissions: montageplan:read, montageplan:update, montageplan:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `montageplanV2ControllerCalculateStatusForTask()` instead.
   *
   * This method doesn't expect any request body.
   */
  montageplanV2ControllerCalculateStatusForTask$Response(
    params: {
      taskId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMontageplanV2Service.MontageplanV2ControllerCalculateStatusForTaskPath, 'post');
    if (params) {
      rb.path('taskId', params.taskId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: montageplan:read, montageplan:update, montageplan:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `montageplanV2ControllerCalculateStatusForTask$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  montageplanV2ControllerCalculateStatusForTask(
    params: {
      taskId: number;
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.montageplanV2ControllerCalculateStatusForTask$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `montageplanV2ControllerLockTeam()` */
  static readonly MontageplanV2ControllerLockTeamPath = '/v2/projects/montageplan/teams/lock/{teamId}';

  /**
   * Required permissions: montageplan:update, montageplan:move, montageplan:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `montageplanV2ControllerLockTeam()` instead.
   *
   * This method doesn't expect any request body.
   */
  montageplanV2ControllerLockTeam$Response(
    params: {
      teamId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMontageplanV2Service.MontageplanV2ControllerLockTeamPath, 'post');
    if (params) {
      rb.path('teamId', params.teamId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: montageplan:update, montageplan:move, montageplan:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `montageplanV2ControllerLockTeam$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  montageplanV2ControllerLockTeam(
    params: {
      teamId: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.montageplanV2ControllerLockTeam$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `montageplanV2ControllerUnlockTeam()` */
  static readonly MontageplanV2ControllerUnlockTeamPath = '/v2/projects/montageplan/teams/unlock/{teamId}';

  /**
   * Required permissions: montageplan:update, montageplan:move, montageplan:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `montageplanV2ControllerUnlockTeam()` instead.
   *
   * This method doesn't expect any request body.
   */
  montageplanV2ControllerUnlockTeam$Response(
    params: {
      teamId: number;
      force?: boolean;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMontageplanV2Service.MontageplanV2ControllerUnlockTeamPath, 'post');
    if (params) {
      rb.path('teamId', params.teamId, {});
      rb.query('force', params.force, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: montageplan:update, montageplan:move, montageplan:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `montageplanV2ControllerUnlockTeam$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  montageplanV2ControllerUnlockTeam(
    params: {
      teamId: number;
      force?: boolean;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.montageplanV2ControllerUnlockTeam$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `montageplanV2ControllerListenToLockStatus()` */
  static readonly MontageplanV2ControllerListenToLockStatusPath = '/v2/projects/montageplan/teams/lockStatus';

  /**
   * Required permissions: montageplan:read, montageplan:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `montageplanV2ControllerListenToLockStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  montageplanV2ControllerListenToLockStatus$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMontageplanLockStatusDtoEvent>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMontageplanV2Service.MontageplanV2ControllerListenToLockStatusPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/event-stream', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMontageplanLockStatusDtoEvent>;
      })
    );
  }

  /**
   * Required permissions: montageplan:read, montageplan:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `montageplanV2ControllerListenToLockStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  montageplanV2ControllerListenToLockStatus(
    params?: {
    },
    context?: HttpContext
  ): Observable<WorkMontageplanLockStatusDtoEvent> {
    return this.montageplanV2ControllerListenToLockStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMontageplanLockStatusDtoEvent>): WorkMontageplanLockStatusDtoEvent => r.body)
    );
  }

}
